export function normalizeExtracoinUsagePercent(raw) {
  if (raw == null) return 0;
  if (typeof raw === "number" && !Number.isNaN(raw)) return raw;
  if (typeof raw === "object") {
    const p = raw.percent ?? raw.percentage;
    if (typeof p === "number" && !Number.isNaN(p)) return p;
  }
  const n = Number(raw);
  return Number.isNaN(n) ? 0 : n;
}
